module.exports = __webpack_public_path__ + "img/twelve.de5e99cd.jpg";